/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * A single point in the answer key with rubric mapping.

Used in both DB-persisted question pool entries and AI-generated exam questions.
 */
export interface AnswerKeyPoint {
  point: string;
  criterion: string;
}
